import * as React from 'react';
import { l } from '../../Other/Translation';
import './styles.scss';

const LOCALSTORAGE_KEY = 'dataConsentMessageShown';

const DataConsentBanner = () => {
  const [isVisible, setIsVisible] = React.useState(!Boolean(localStorage.getItem(LOCALSTORAGE_KEY)));
  if (!isVisible) { return null; }
  return <div className="dataConsentBanner"
  >
    <div dangerouslySetInnerHTML={
      { __html: l('dataConsentBanner.text') }
    }></div>
    <span className="actionLink" onClick={(e) => {
      localStorage.setItem(LOCALSTORAGE_KEY, 'true');
      setIsVisible(false);
      e.preventDefault();
    }}>
      {l('general.OK')}
    </span>
  </div>;
};

export default DataConsentBanner;
